import { Children, isValidElement } from 'react';

/**
 * Gets only the valid children of a component,
 * and ignores any nullish or falsy child.
 *
 * @param children the children
 * @see Accordion Button StepIndicator Tabs WorkflowBar
 */
export default function getValidChildren(children) {
  return Children.toArray(children).filter(child => /*#__PURE__*/isValidElement(child));
}
//# sourceMappingURL=getValidChildren.js.map